import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { ToggleButton } from 'components/Input/ToggleButton'
import { Modal } from 'components/Modal/Modal'
import { addCapability, editCapability } from 'features/capabilities/capabilitiesSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { CursorPointer, Flex } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { TitleText } from 'styling/Typography'
import { ICapability } from 'types/api/capabilitiesApi.interface'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const CapabilitiesModal = ({ closeModal, value }: { closeModal: any, value?: ICapability }) => {
    const [state, setState] = useState<ICapability>(value || {
        name: '',
        code: '',
        requiresExpiry: false,
        requiresDocument: false,
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, name: string) => {
        setState({ ...state, [name]: e.target.value })
    }

    const handleSave = async () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const resp = await dispatch(value?.id ? editCapability({ ...state, id: value.id }) : addCapability(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }


    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Capablilty</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Flex gap='1rem' >
                    <Input placeholder='Enter capability name...' labelText='Name' value={state.name} onChange={e => handleChange(e, 'name')} nomarg />
                    <Input placeholder='Enter capability code...' labelText='Code' value={state.code} onChange={e => handleChange(e, 'code')} nomarg />
                </Flex>
                <Flex between >
                    <ToggleButton
                        start
                        label='Requires Expiry'
                        state={state.requiresExpiry || false}
                        handleChange={() => setState(prev => ({ ...prev, requiresExpiry: !prev.requiresExpiry }))}
                    />
                    <ToggleButton
                        start
                        label='Requires Document'
                        state={state.requiresDocument || false}
                        handleChange={() => setState(prev => ({ ...prev, requiresDocument: !prev.requiresDocument }))}
                    />
                </Flex>

            </Flex>
            <Button style={{ marginTop: '16px' }} disabled={!state.code || !state.name} variant='primary' onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

